import {AxiosError} from "axios";

export class SiteBunnyError extends Error {
    constructor(public code: string, message?: string, noErrorPage?: boolean) {
        super(message);
        Object.setPrototypeOf(this, SiteBunnyError.prototype);
        this.noErrorPage = noErrorPage;
    }

    public readonly isSiteBunnyError = true;
    public noErrorPage?: boolean;
}

type ErrorWithMessage = {
    message: string;
};

export const isErrorWithMessage = (error: unknown): error is ErrorWithMessage => {
    try {
        return (
            typeof error === "object" && error !== null && "message" in error && typeof (error as Record<string, unknown>).message === 'string'
        );
    } catch (e) {
        return false
    }
}

export const isAxiosError = (error: unknown): error is AxiosError => {
    try {
        return (
            typeof error === "object" && error != null && "isAxiosError" in error && typeof (error as Record<string, unknown>).isAxiosError === "boolean"
        )
    } catch (e) {
        return false;
    }
};

export const isSiteBunnyError = (error: unknown): error is SiteBunnyError => {
    try {
        return (
            typeof error === "object" && error != null && "isSiteBunnyError" in error && typeof (error as Record<string, unknown>).isSiteBunnyError === "boolean"
        )
    } catch (e) {
        return false;
    }
}

export const toSiteBunnyError = (unknownError: unknown, options?: {code?: string, noErrorPage?: boolean}, redirect?: () => void): SiteBunnyError => {

    if (isAxiosError(unknownError)) {
        if (redirect) {
            redirect()
        } else {
            return new SiteBunnyError(String(unknownError.response?.status) ?? "500", unknownError.message, options?.noErrorPage);
        }
    }

    if (isSiteBunnyError(unknownError)) {
        return unknownError;
    }

    if (isErrorWithMessage(unknownError)) {
        return new SiteBunnyError(options?.code ?? "500", unknownError.message, options?.noErrorPage);
    }

    try {
        return new SiteBunnyError(options?.code ?? "500", JSON.stringify(unknownError));
    } catch {
        return new SiteBunnyError(options?.code ?? "500", String(unknownError), options?.noErrorPage);
    }
};
